import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { brand } from '../../config/brand';
import BrandLogo from '../../components/BrandLogo';

const GoogleSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setTokens } = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    const error = searchParams.get('error');
    const token = searchParams.get('token');
    const refreshToken = searchParams.get('refresh');

    if (error) {
      navigate('/login?error=oauth_failed', { replace: true });
      return;
    }

    if (token && refreshToken) {
      try {
        // base64url → base64: replace URL-safe chars and add padding
        const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
        const payload = JSON.parse(atob(padded));

        // Only store tokens after successful decode
        setTokens(token, refreshToken);
        window.location.replace(
          payload.needsOnboarding ? brand.onboardingRoute : brand.defaultRoute,
        );
      } catch {
        // Token decode failed — still store and go to the default landing route
        setTokens(token, refreshToken);
        window.location.replace(brand.defaultRoute);
      }
    } else {
      navigate('/login?error=oauth_failed', { replace: true });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-dark-bg dark:bg-dark-bg bg-light-bg flex items-center justify-center">
      <div className="text-center">
        <BrandLogo
          imgClassName="h-10 w-auto mx-auto mb-4"
          textClassName="block mb-4 text-2xl font-bold tracking-tight text-dark-text dark:text-dark-text text-light-text"
        />
        <h1 className="text-xl font-semibold text-dark-text dark:text-dark-text text-light-text">
          {t('auth.completingSignIn', 'Completing sign in...')}
        </h1>
        <p className="text-dark-text-secondary dark:text-dark-text-secondary text-light-text-secondary mt-2">
          {t('auth.settingUpAccount', 'Please wait while we finish setting up your account.')}
        </p>
      </div>
    </div>
  );
};

export default GoogleSuccess;
